import React from 'react';
import { Route } from 'react-router-dom';
import { TicketDashboardPage } from './TicketsDashboardPage';

export const routes = [<Route key="0" exact path="/" component={TicketDashboardPage} />];

export const navigation = [{ name: 'overview', link: '/', exact: true, icon: 'Dashboard' }];
